import { Turbo } from '@hotwired/turbo-rails'
import { login_path } from '~/routes';
const Login = {

  login: function(){
    ActionJS.Login._initLoginLayout();
  },

  confirm_login: function(){
    ActionJS.Login._initLoginLayout();
  },

  login_message: function(){
    ActionJS.Login._initLoginLayout();
  },

  reset_password: function(){
    ActionJS.Login._initLoginLayout();
  },
  
  confirm_reset_password: function(){
    ActionJS.Login._initLoginLayout();
  },

  enter_new_password: function(){
    ActionJS.Login._initLoginLayout();
  },

  confirm_enter_new_password: function(){
    ActionJS.Login._initLoginLayout();
  },

  mobile_qr: function(){
    ActionJS.Login._initLoginLayout();
  },
  
  _initFundLoginLayout: function () {
    const pageReady = () => {
      const theme = getComputedStyle(document.documentElement).getPropertyValue('--footer-logo-type').trim();
      if (theme) {
        document.querySelector('img.footer-logo').src = `/images/SmartME_M_horizontal_${theme}.png`;
      }
      resizeBackground()
      startLoginBgShow()
      ActionJS.Login._initLoginStatusList();
    }

    const startLoginBgShow = async () => {
      const root = document.querySelector(".login-bg");
      if (!root) return;

      const a = root.querySelector(".layer-a");
      const b = root.querySelector(".layer-b");
      if (!a || !b) return;

      const max = 5;
      const defs = JSON.parse(root.dataset.defaultImages || "[]");
      const customs = JSON.parse(root.dataset.backgroundImages || "[]");
      const srcs = (customs.length ? customs : defs)
        .slice(0, max)
        .map((x) => (typeof x === "string" ? x : x.path || x.url || x.src || ""))
        .filter(Boolean)

      if (!srcs.length) return;

      let currentIndex = 0;
      let timer = null;
      let busy = false;
      let format = await new Promise(res => {
        const image = new Image();
        image.onload = () => res("avif");
        image.onerror = () => res("jpg");
        image.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=";
      }).catch(() => "jpg");

      const sizeKey = () => {
        const width = window.innerWidth;
        const height = window.innerHeight;
        const targetRatio = 16 / 9;
        const currentRatio = width / height;

        // Determine the "effective width" required to cover the area
        const effectiveWidth = currentRatio > targetRatio 
          ? width 
          : height * targetRatio;

        if (effectiveWidth >= 1921) return "qhd";
        if (effectiveWidth >= 1281) return "fhd";
        return "hd";
      };

      const orderFor = (s) =>
        s === "qhd" ? ["qhd", "fhd", "hd"] : s === "fhd" ? ["fhd", "hd"] : ["hd"];
      const urlOf = (base, size, fmt) => {
        if (base.toLowerCase().endsWith('.svg')) {
          return base;
        }
        return `${base}${customs.length ? `?variant=${size}_${fmt}` : ''}`;
      }
      const clearVars = (el) => ["--hd-avif", "--hd-jpg", "--fhd-avif", "--fhd-jpg", "--qhd-avif", "--qhd-jpg"].forEach(v => el.style.removeProperty(v));

      const test = (url) => {
        return new Promise((res) => {
          const i = new Image();
          let done = false;
          const finish = (v) => {
            if (!done) {
              done = true;
              res(v);
            }
          };
          i.onload = () => finish(true);
          i.onerror = () => finish(false);
          i.decoding = "async";
          i.src = url;
          if (i.decode) {
            i.decode()
              .then(() => finish(true))
              .catch(() => finish(false));
          }
        });
      }

      // Fetch highest working resolution for image src, as uploaded backgrounds may be under desired resolution.
      const findWorking = async (base, sizes) => {
        for (const s of sizes) {
          const imgUrl = urlOf(base, s, format);
          if (await test(imgUrl))
            return { size: s, url: imgUrl };
        }
        return null;
      };

      const setTier = async (el, base) => {
        const sizes = orderFor(sizeKey());
        const chain = orderFor("qhd");
        const ok = await findWorking(base, sizes);
        clearVars(el);
        if (!ok) return;

        const typeStr = format === "avif" ? "image/avif" : "image/jpeg";
        const ix = chain.includes(ok.size) ? chain.indexOf(ok.size) : chain.length - 1;

        chain.forEach((s, i) => {
          const url = i <= ix ? ok.url : urlOf(base, s, format);
          el.style.setProperty(`--${s}`, `url("${url}") type("${typeStr}")`);
        });
      };

      const show = async (idx, a, b, srcs) => {
        const elIn = !a.classList.contains('is-live') ? a : b;
        const elOut = elIn === a ? b : a;

        await setTier(elIn, srcs[idx]);
        void elIn.offsetWidth;
        const done = new Promise(r => elIn.addEventListener('transitionend', r, { once: true }));
        elIn.classList.add('is-live');

        await done;
        elIn.classList.remove('preview');
        elOut.classList.remove('preview');
        elOut.classList.remove('is-live');
      };

      const tick = () => {
        if (srcs.length === 1) return;
        timer = setTimeout(async () => {
          clearTimeout(timer);
          if (busy) return tick();
          busy = true;
          const nxt = (currentIndex + 1) % srcs.length;
          await show(nxt, a, b, srcs);
          currentIndex = nxt;
          busy = false;
          tick();
        }, 30000);
      };

      setTier(a, srcs[currentIndex]).then(() => {
        a.classList.add("is-live");
        tick();
      });
    };

    const resizeBackground = () => {
      var h = jQuery(window).height() - jQuery('.intro-container').height() - jQuery('footer').height() - jQuery('header').height() - jQuery('.navbar').height()
      var mainHeight = jQuery('#main-container').height() + (jQuery('#main-container').length > 0 ? jQuery('#main-container').position().top : 0)
      h = h < mainHeight ? mainHeight : h
      jQuery('.login-carousel').css({height: h})
    }
      window.addEventListener("resize", resizeBackground, { passive: true });

    pageReady()
  },


  _initLoginLayout: function(){
    function pageReady() {
      resizeBackground();
      startLoginBgShow();
      ActionJS.Login._initLoginStatusList();
    }

    function startLoginBgShow() {
        new SlideRoller('.background-container .img', {
            interval: 30000,
            transitionDuration: 1000,
            randomPlay: true
        });
    }

    function resizeBackground() {
        var h = jQuery(window).height() - jQuery('.intro-container').height() - jQuery('footer').height() - jQuery('header').height() - jQuery('.navbar').height();
        var mainHeight = jQuery('#main-container').height() + (jQuery('#main-container').length > 0 ? jQuery('#main-container').position().top : 0)
        h = h < mainHeight ? mainHeight : h;
        jQuery('.background-container').css({height: (h)});
    }

    // Redirect to login page if login page is loaded as a partial
    jQuery('body:not(.login) form.login:first').each(function() {
      jQuery('body').html(SmartME.loadingIndicator());
      Turbo.visit(login_path({format: null}));
    });


    // clear sessionStorage for xwiki partial loading
    // jQuery('body.login').each(function(){
    //     sessionStorage.clear();
    // });



    jQuery(window).on('resize', resizeBackground);
    pageReady();  
  },

  _initLoginStatusList: function() {
      jQuery('body').delegate('.login-status-row', 'click', function() {
        var $this = jQuery(this);
        var loginInDialog = ($this.closest('#modal-dialog').length > 0);

        if ($this.is('.logout')) {
          $("<form>", {method: 'POST', action: $(this).data('login-route')})
            .append($("<input>", {type: 'hidden', name: 'authenticity_token', value: $('meta[name="csrf-token"]').attr('content')}))
            .appendTo('body').submit();
        }
        else if ($this.is(':not(.previous)')) {
          if (!loginInDialog) {
            Turbo.visit(jQuery(this).data('login-route'));
          }
        }
      });
  }

};

export default Login;